import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="py-12 px-6 bg-burgundy-deep border-t border-gold/20" data-id="element-46">
      <div className="max-w-6xl mx-auto" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="text-center space-y-6" data-id="element-48">
          <div data-id="element-49">
            <h3 className="text-2xl font-playfair text-gold-bright mb-2" data-id="element-50">
              Deseo & Intimidad
            </h3>
            <p className="text-cream/60 font-cormorant italic text-lg" data-id="element-51">
              El Renacimiento
            </p>
          </div>

          <div className="w-16 h-[1px] bg-gold/40 mx-auto" data-id="element-52" />

          <p className="text-cream/50 text-sm tracking-wide" data-id="element-53">
            © {new Date().getFullYear()} Todos los derechos reservados
          </p>
        </motion.div>
      </div>
    </footer>;
}